module.exports = __webpack_public_path__ + "img/1499209946.49f35be8.jpg";